import { Center, CenterProps } from "@chakra-ui/react";
import { DropzoneState } from "react-dropzone";

export type DropzoneWellProps = CenterProps & {
  dropzone: DropzoneState;
  isDisabled?: boolean;
};

export default function DropzoneWell({
  dropzone,
  children,
  isDisabled,
  ...rest
}: DropzoneWellProps) {
  const { getRootProps, getInputProps, isDragAccept, isDragReject } = dropzone;
  const inputProps = getInputProps();
  return (
    <Center
      {...getRootProps()}
      backgroundColor="cardBackground"
      data-valid={isDragAccept || undefined}
      data-invalid={isDragReject || undefined}
      color="gray.600"
      borderColor="transparent"
      borderWidth={2}
      p={6}
      minHeight="4rem"
      borderRadius={10}
      cursor="pointer"
      transition="all 300ms ease"
      aria-disabled={isDisabled || inputProps.disabled || undefined}
      _disabled={{ opacity: 0.65, cursor: "not-allowed" }}
      _valid={{
        borderColor: "green",
        backgroundColor: "green.100",
        color: "green.700",
      }}
      _invalid={{
        borderColor: "red",
        backgroundColor: "red.100",
        color: "red.700",
      }}
      {...rest}
    >
      <input {...inputProps} />
      {children}
    </Center>
  );
}
